import { z } from 'zod'

export const AttachedFileSchema = z.object({
  key: z.string(),
  filename: z.string(),
})

export type AttachedFile = z.infer<typeof AttachedFileSchema>
